export default __webpack_public_path__ + "static/media/icon_intelligence_musical.6587efc8.svg";